export const canonicalServiceTypes = ['cleaning', 'parking', 'fueling-or-charging', 'assembly'] as const;

export const serviceOrderStopNameSeparator = ' · ';

export type CanonicalServiceType = (typeof canonicalServiceTypes)[number];

export type ParsedServiceOrderStopName = {
    serviceType: string;
    company: string;
};

export const isCanonicalServiceType = (value: string): value is CanonicalServiceType =>
    canonicalServiceTypes.includes(value as CanonicalServiceType);

export const parseServiceOrderStopName = (value: string): ParsedServiceOrderStopName => {
    const separatorIndex = value.indexOf(serviceOrderStopNameSeparator);

    if (separatorIndex === -1) {
        return { serviceType: value.trim(), company: '' };
    }

    return {
        serviceType: value.slice(0, separatorIndex).trim(),
        company: value.slice(separatorIndex + serviceOrderStopNameSeparator.length).trim(),
    };
};

export const serializeServiceOrderStopName = (serviceType: string, company?: string): string => {
    const normalizedServiceType = serviceType.trim();
    const normalizedCompany = company?.trim() ?? '';

    return normalizedCompany
        ? `${normalizedServiceType}${serviceOrderStopNameSeparator}${normalizedCompany}`
        : normalizedServiceType;
};
